module.exports = __webpack_public_path__ + "static/media/117-angola.8a024845.svg";